import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux'
import CommissionService from 'services/CommissionService';
import {withRouter} from "react-router";
import {DemandValidation} from 'constants/DemandValidation';
import {isDemandModification} from "libs/getDemandStatus";
import ModificationService from "services/ModificationService";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import CommissionForm from "components/complex/commissionForm/CommissionForm";
import {simpleConfirm} from "libs/ConfirmNotification";
import Confirm from "components/popup/confirm/Confirm";
import {setFormDraftLoaded} from "redux/actions";
import Loading from 'components/Loading';
import saveFormDraft from "libs/saveFormDraft";

function DemandCommissionForm(
    {
        classes,
        stepperState,
        match,
        commissionUserList,
        userListAvailable,
        establishmentDate,
        demandValidation,
        setFormDraftLoaded,
        demandHeader
    }) {
    const section = demandValidation.find(x => x.section === DemandValidation.COMMISSION);
    const FORM_ID = 'mp_1_commission'
    const demandId = match.params.id;
    const [draftConfirm, setDraftConfirm] = useState(false);
    const [working, setWorking] = useState(false);
    const autoSaveFormDraftActive = demandHeader?.applicationClientSettings.autoSaveFormDraft.active;
    useStepperStateCloseValidator(FORM_ID, undefined,
        autoSaveFormDraftActive ? () => CommissionService.deleteDraft(demandId) : undefined,
        autoSaveFormDraftActive ? () => saveFormDraft(demandId, CommissionService.saveDraft, FORM_ID) : undefined);

    useEffect(() => {
        CommissionService.getUsers(demandId).then(() => {
            if (autoSaveFormDraftActive)
                CommissionService.checkForDraft(demandId).then(res => setDraftConfirm(res.result));
        });
        CommissionService.getAvailableUsers(demandId);

        return () => {
            CommissionService.clearResources(CommissionService.COMMISSION_USER_LIST_RESOURCE_ID);
            CommissionService.clearResources(CommissionService.COMMISSION_USER_LIST_AVAILABLE_RESOURCE_ID);
            CommissionService.clearResources(CommissionService.COMMISSION_ESTABLISHMENT_RESOURCE_ID);
        }
    }, [demandId, autoSaveFormDraftActive])


    const markHistorical = (memnerId) => {
        simpleConfirm("archive_commission_member_info", () => CommissionService.markHistorical(demandId, memnerId))
    }

    const handleSubmit = (values) => {
        CommissionService.saveUserList(demandId, values)
    }

    const doLoadHistory = async () => {
        return await CommissionService.getHistory(demandId);
    }

    const loadCommissionDraft = () => {
        setDraftConfirm(false);
        setWorking(true);
        CommissionService.loadDraft(demandId).then(res => setFormDraftLoaded(FORM_ID, res.success));
        setWorking(false);
    }

    if (working) return <Loading/>
    else return (
        <>
            <CommissionForm
                commissionUserList={commissionUserList}
                userListAvailable={userListAvailable}
                establishmentDate={establishmentDate}
                afterSubmitFunc={() => {
                    if (isDemandModification()) {
                        ModificationService.isDemandChanged(demandId);
                    }
                }}
                editable={section ? section.editable : true}
                handleSubmit={handleSubmit}
                formId={FORM_ID}
                demandId={demandId}
                doLoadHistory={doLoadHistory}
                markHistorical={markHistorical}
                saveDraftFunc={CommissionService.saveDraft}
                autoSaveFormDraftActive={autoSaveFormDraftActive}
            />
            <Confirm
                open={draftConfirm}
                onConfirm={loadCommissionDraft}
                onCancel={() => setDraftConfirm(false)}
                confirmText="form_draft_load_confirm_text"
                confirmTitle="form_draft_load_confirm_title"
            />
        </>
    )
}

DemandCommissionForm.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    stepperState: state.stepper.state,
    commissionUserList: state.resources[CommissionService.COMMISSION_USER_LIST_RESOURCE_ID],
    userListAvailable: state.resources[CommissionService.COMMISSION_USER_LIST_AVAILABLE_RESOURCE_ID],
    establishmentDate: state.resources[CommissionService.COMMISSION_ESTABLISHMENT_RESOURCE_ID],
    demandValidation: state.resources.demandValidation,
    demandHeader: state.resources.demandHeader
}), {setFormDraftLoaded})(withRouter(DemandCommissionForm));
